<template>
  <div class="p-6 all">
    <div>
      <div class="flex items-center mb-12 justify-between">
        <div
          class="w-2/3 font-c7 text-left text-c34 2xl:text-c42 text-black inputo 2xl:mt-5"
        >
          Statistiques
        </div>
        <div class="flex justify-center items-center gap-4">
          <!-- Bouton export -->
          <Boutton
            v-if="user && user.isViewer === true"
            background="#312879"
            color="#fff"
            label="Exporter"
            @click="handleExport"
            :charge="charge"
            class="w-44"
          >
            Exporter
          </Boutton>
          <!-- Multi-date -->
          <multiDate
            @info="updateDateFilter"
            class="w-80"
          />
        </div>
      </div>
    </div>

    <div class="flex">
      <div class="w-full">
        <!-- Passer les données au composant stats -->
        <stats
          :stats="stats"
          :account-data="accountData"
        />
      </div>
    </div>

    <div
      class="mt-10 rounded-10 h-auto flex"
      v-if="user && user.userType === 'ADMIN'"
    >
      <div class="w-full">
        <sfd
          :stats="stats"
          :account-data="accountData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import stats from "../../component/cdevs/dashboard/stats";
import sfd from "../../component/cdevs/dashboard/evolutionInscrpit";
import { ref, computed } from "vue";
import { useStore } from "vuex";
import multiDate from "../../component/helper/form/multipleDate.vue";
import {
  getAdminGlobalData,
  getAllComptable,
  exportExcelInfo
} from "@/component/cdevs/allFunctions";
import apiroutes from "../../../src/router/api-routes";
import http from "../../../src/plugins/https";
import Boutton from "../../component/helper/add/button.vue";
import * as XLSX from 'xlsx'

export default {
  name: "Index",
  components: {
    stats,
    sfd,
    multiDate,
    Boutton,
  },
  setup() {
    const store = useStore();
    const user = computed(() => store.getters.trackUser?.user ?? null);
    const stats = ref({
      programs: 0,
      accountant: 0,
      certifiedAccountant: 0,
      companyAffectation: 0,
      serviceRequest: 0,
      awaitServiceRequest: 0,
      awaitAccountantRequest: 0,
    });
    const accountData = ref({
      allCompany: 0,
      activeCompany: 0,
      awaitNormalize: 0,
      endNormalize: 0,
      rejectedNormalize: 0,
      partner: 0,
    });

    // Variables pour les dates de filtre
    const startDate = ref("01/01/2020");
    const endDate = ref(new Date().toISOString().split("T")[0]);
    // Fonction pour mettre à jour les dates de filtre
    const updateDateFilter = (range) => {
      startDate.value = range.start;
      endDate.value = range.end;
      getData(); // Recharger les données avec les nouvelles dates
      getDataAccount(); // Recharger les données comptables
    };

    const getData = async () => {
      const data = {
        apiKey: process.env.VUE_APP_OLD_X_PRIVATE_KEY,
        startDate: startDate.value,
        endDate: endDate.value,
      };
      try {
        const response = await getAdminGlobalData(data);
        console.log("Response getAdminGlobalData", response);
        stats.value = {
          programs: response.programs || 0,
          accountant: response.accountant || 0,
          certifiedAccountant: response.certifiedAccountant || 0,
          companyAffectation: response.companyAffectation || 0,
          serviceRequest: response.serviceRequest || 0,
          awaitServiceRequest: response.awaitServiceRequest || 0,
          awaitAccountantRequest: response.awaitAccountantRequest || 0,
        };
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };

    const getDataAccount = async () => {
      try {
        const response = await http.post(
          apiroutes.baseURL + apiroutes.get_all_comptable,
          {
            apiKey: process.env.VUE_APP_OLD_X_PRIVATE_KEY,
            startDate: startDate.value,
            endDate: endDate.value,
          }
        );
        console.log("Response get all comptable", response);
        accountData.value = {
          allCompany: response.allCompany || 0,
          activeCompany: response.activeCompany || 0,
          awaitNormalize: response.awaitNormalize || 0,
          endNormalize: response.endNormalize || 0,
          rejectedNormalize: response.rejectedNormalize || 0,
          partner: response.partner || 0,
        };
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des données comptables :",
          error
        );
      }
    };

    const downloadExcelData = (items) => {
        if (!items || items.length === 0) {
          this.$toast.error('Aucune donnée à télécharger.')
          return
        }

        const data = XLSX.utils.json_to_sheet(items)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, data, 'Agents')
        XLSX.writeFile(wb, `stat_${new Date().getTime()}.xlsx`)
      };

    // Exporter les informations au format Excel
    const charge = ref(false);
    const handleExport = async () => {
      charge.value = true;
      const data = {
        apiKey: process.env.VUE_APP_OLD_X_PRIVATE_KEY,
        startDate: startDate.value,
        endDate: endDate.value,
      };
      try {
        const response = await exportExcelInfo(data);
        console.log("Response exportExcelInfo", response);
        
        // Télécharger le fichier Excel (response est un blob)
        if (response) {
           downloadExcelData(response);
          
          // Toast de succès
          this.$toast.success("Export effectué avec succès !");
        } else {
          this.$toast.error("Aucun fichier reçu pour l'export.");
        }
      } catch (error) {
        console.error("Erreur lors de l'exportation des informations :", error);
        // Toast d'erreur
        this.$toast.error("Erreur lors de l'export. Veuillez réessayer.");
      } finally {
        charge.value = false;
      }
    };
    

    return {
      user,
      stats,
      accountData,
      startDate,
      endDate,
      updateDateFilter,
      getData,
      getDataAccount,
      handleExport,
      charge
    };
  },
  mounted() {
    this.getData();
    this.getDataAccount();
  },
};
</script>
